import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import FieldError from '../../../../../shared/fields-errors/field-error';
import { useEffect, useState } from 'react';
import { PUBLISH_WIDGET } from '../../../../../constants/endpoints';
import axios from 'axios';
import Loader from '../../../../../shared/loader/loader';
import { SETTINGS } from '../../../../../constants/widget.constant';
import ThermometerWidget from './thermometer-goal-widget';
import ProgressBarWidget from './goal-bars/progress-bar';
import ThermometerGoalWidget from './goal-bars/thermometer';
import DonationCardWidget from './goal-bars/donation-card';

const PRESET_COLORS = [
    '#0047AB', '#1A6B4A', '#7C3AED', '#DC2626', '#D97706', '#0D9488'
];

const WidgetConfigurator = (props) => {
    const [dataLoader, setDataLoader] = useState(false);
    const [settings, useSettings] = useState(props?.widgets?.settings ? props?.widgets?.settings : null);
    const navigate = useNavigate();
    const widgetType = props?.widget;
    const widgets = props?.widgets;
    const target_id = props?.target_id;
    const type = props?.campaignType;
    const [isDark, setIsDark] = useState(props?.widget === 'goal' ? props?.widgets?.settings?.goal?.dark_mode : null)

    const methods = useForm(
        {
            defaultValues: {
                ...(widgetType === 'button' ? { background_color: '#ffffff' } : {}),
                ...(widgetType === 'button' ? { text_color: '#000000' } : {}),
                ...(widgetType === 'button' ? { border_color: '#d6d6d6' } : {}),
                ...(widgetType === 'button' ? { corner_radius: 10 } : {}),
                ...(widgetType === 'button' ? { border_outline: 1 } : {}),
                ...(widgetType === 'button' ? { icon_position: 'left' } : {}),
                ...(widgetType === 'button' ? { button_shadow: false } : {}),
                ...(widgetType === 'button' ? { button_type: 'static' } : {}),
                ...(widgetType === 'button' ? { icon: 'none' } : {}),
                ...(widgetType === 'button' ? { button_text: 'Donate' } : {}),
                ...(widgetType === 'button' ? { z_index: 0 } : {}),
                ...(widgetType === 'goal' ? { progress_bar_color: '#0047AB' } : {}),
                ...(widgetType === 'goal' ? { progress_bar_type: 'bar' } : {}),
                ...(widgetType === 'goal' ? { dark_mode: false } : {}),
                ...(widgetType === 'goal' ? { size: 'medium' } : {}),
                ...(widgetType === 'goal' ? { border_outline: 1 } : {}),
                ...(widgetType === 'goal' ? { show_campaign: false } : {}),
                ...(widgetType === 'goal' ? { show_description: true } : {}),
                ...(widgetType === 'goal' ? { show_donations: true } : {}),
                ...(widgetType === 'goal' ? { show_donate_btn: true } : {}),
                ...(widgetType === 'goal' ? { btn_text: 'Donate Now' } : {}),
            }
        }
    );
    const { reset, getValues, watch, setValue, formState: { isValid, errors } } = methods;
    const formFields = watch();

    const { register } = methods;

    const previewStyle = {
        backgroundColor: formFields?.background_color,
        color: formFields?.text_color,
        border: formFields?.border_outline > 0 ? `${formFields?.border_outline}px solid ${formFields?.border_color}` : 'none',
        borderRadius: `${formFields?.corner_radius}px`,
        boxShadow: formFields?.button_shadow ? '2px 4px 6px rgba(0,0,0,0.15)' : 'none',
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: '600',
        gap: '4px',
        padding: formFields?.icon === 'none' ? '8px 35px' : '8px 20px',
        position: formFields?.button_type === 'floating' ? 'fixed' : 'static',
        zIndex: formFields?.button_type === 'floating' ? 1000 : 0,
        top: formFields?.button_type === 'floating' ? '0' : '',
    };

    const publishWidgetSettings = (formValues) => {
        setDataLoader(true);
        const newSettings = settings ? settings : structuredClone(SETTINGS);
        newSettings[widgetType] = formValues;
        newSettings[widgetType].dark_mode = isDark;
        const formData = {
            settings: newSettings,
            target_id: target_id,
            target_type: type
        }
        axios.post((PUBLISH_WIDGET + `${widgets?.widget_id ? widgets?.widget_id : 'new'}`), formData)
            .then((res) => {
                setDataLoader(false);
                if (res?.data?.status) {
                    navigate(`/sharing-donation/${target_id}/${type}`)
                }
            }).catch((error) => {
                setDataLoader(false);
            });
    }

    useEffect(() => {
        if (settings) {
            if (widgetType === 'button') {
                reset(settings?.button);
            }
            else if (widgetType === 'goal') {
                reset(settings?.goal);
            }
        }
    }, [settings])

    const isCard = formFields?.progress_bar_type === 'donation_card';
    const isLarge = formFields?.size === 'large';
    const isSmall = formFields?.size === 'small';
    const showCampaignRow = !isCard && isLarge;
    const showDescRow = isCard && !isSmall;
    const showBtnRow = isCard;
    const showBtnTextSection = isCard;
    const showCountRow = !isSmall;

    return (
        <div className='position-relative'>
            <style>{CONFIG_CSS}</style>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(publishWidgetSettings)}>

                    <div className="config-grid">

                        <div className="form-card">
                            {widgetType === 'goal' && (
                                <div className="sub-section">
                                    <div className="sub-label">Widget</div>
                                    <div className="card-row">
                                        <div className="form-group">
                                            <label className="cfg-form-label">Widget type</label>
                                            <select
                                                {...register("progress_bar_type")}
                                                className="cfg-form-select"
                                                value={formFields?.progress_bar_type}
                                            >
                                                <option value="bar">Progress bar</option>
                                                <option value="thermometer">Thermometer</option>
                                                <option value="donation_card">Donations card</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="cfg-form-label">Size</label>
                                            <div className="size-selector">
                                                {['small', 'medium', 'large'].map((s) => (
                                                    <button
                                                        key={s}
                                                        type="button"
                                                        className={`size-btn${formFields?.size === s ? ' active' : ''}`}
                                                        onClick={() => setValue('size', s)}
                                                    >
                                                        {s[0].toUpperCase()}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ── BUTTON Widget Type Fields ── */}
                            {widgetType === 'button' && (
                                <>
                                    <div className="sub-section">
                                        <div className="sub-label">Widget</div>
                                        <div className="card-row">
                                            <div className="form-group">
                                                <label className="cfg-form-label">Button type</label>
                                                <select {...register("button_type")} className="cfg-form-select" value={formFields?.button_type}>
                                                    <option value="static">Static</option>
                                                    <option value="floating">Floating</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label className="cfg-form-label">Button text</label>
                                                <input
                                                    type="text"
                                                    {...register("button_text", { required: { value: true, message: "Field is required" } })}
                                                    className="cfg-form-input"
                                                    value={formFields?.button_text}
                                                    maxLength={30}
                                                />
                                                {errors?.button_text ? <FieldError message={errors?.button_text?.message} /> : ""}
                                            </div>
                                        </div>
                                        <div className="card-row" style={{ marginTop: '12px' }}>
                                            <div className="form-group">
                                                <label className="cfg-form-label">Icon</label>
                                                <select {...register("icon")} className="cfg-form-select" value={formFields?.icon}>
                                                    <option value="heart">Heart</option>
                                                    <option value="gift">Gift</option>
                                                    <option value="none">No icon</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label className="cfg-form-label d-block">Icon alignment</label>
                                                <div className="d-flex align-items-center gap-3" style={{ paddingTop: '6px' }}>
                                                    <label className="d-flex align-items-center gap-1" style={{ fontSize: '13px', cursor: 'pointer' }}>
                                                        <input {...register("icon_position")} type="radio" value="left" /> Left
                                                    </label>
                                                    <label className="d-flex align-items-center gap-1" style={{ fontSize: '13px', cursor: 'pointer' }}>
                                                        <input {...register("icon_position")} type="radio" value="right" /> Right
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cfg-form-divider"></div>

                                    {/* ── Branding ── */}
                                    <div className="sub-section">
                                        <div className="sub-label">Branding</div>
                                        <div className="card-row">
                                            <div className="form-group">
                                                <label className="cfg-form-label">Background color</label>
                                                <div className="color-input">
                                                    <input
                                                        type="color"
                                                        {...register("background_color")}
                                                        value={formFields?.background_color}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="hex-text"
                                                        value={formFields?.background_color}
                                                        onChange={(e) => {
                                                            if (/^#[0-9a-fA-F]{6}$/.test(e.target.value)) {
                                                                setValue('background_color', e.target.value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="cfg-form-label">Text color</label>
                                                <div className="color-input">
                                                    <input
                                                        type="color"
                                                        {...register("text_color")}
                                                        value={formFields?.text_color}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="hex-text"
                                                        value={formFields?.text_color}
                                                        onChange={(e) => {
                                                            if (/^#[0-9a-fA-F]{6}$/.test(e.target.value)) {
                                                                setValue('text_color', e.target.value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cfg-form-divider"></div>

                                    {/* ── Border ── */}
                                    <div className="sub-section">
                                        <div className="sub-label">Border</div>
                                        <div className="card-row">
                                            <div className="form-group">
                                                <label className="cfg-form-label">Border color</label>
                                                <div className="color-input">
                                                    <input
                                                        type="color"
                                                        {...register("border_color")}
                                                        value={formFields?.border_color}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="hex-text"
                                                        value={formFields?.border_color}
                                                        onChange={(e) => {
                                                            if (/^#[0-9a-fA-F]{6}$/.test(e.target.value)) {
                                                                setValue('border_color', e.target.value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label className="cfg-form-label">Corner radius</label>
                                                <div className="slider-row">
                                                    <span className="slider-val">{formFields?.corner_radius}</span>
                                                    <input
                                                        type="range"
                                                        {...register("corner_radius")}
                                                        min={0}
                                                        max={20}
                                                        value={formFields?.corner_radius}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-row" style={{ marginTop: '12px' }}>
                                            <div className="form-group">
                                                <label className="cfg-form-label">Outline size</label>
                                                <div className="slider-row">
                                                    <span className="slider-val">{formFields?.border_outline}</span>
                                                    <input
                                                        type="range"
                                                        {...register("border_outline")}
                                                        min={0}
                                                        max={5}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cfg-form-divider"></div>

                                    {/* ── Style ── */}
                                    <div className="sub-section">
                                        <div className="sub-label">Style</div>
                                        <div className="toggle-row">
                                            <div>
                                                <div className="toggle-label">Button shadow</div>
                                                <div className="toggle-desc">Enable background shadow</div>
                                            </div>
                                            <label className="cfg-toggle">
                                                <input type="checkbox" {...register("button_shadow")} />
                                                <span className="cfg-toggle-track"></span>
                                            </label>
                                        </div>
                                    </div>
                                </>
                            )}

                            {widgetType === 'goal' && <div className="cfg-form-divider"></div>}

                            {/* ── BRANDING Section ── */}
                            {widgetType === 'goal' && (
                                <div className="sub-section">
                                    <div className="sub-label">Branding</div>
                                    <div className="card-row">
                                        <div className="form-group">
                                            <label className="cfg-form-label">Accent color</label>
                                            <div className="color-input">
                                                <input
                                                    type="color"
                                                    {...register("progress_bar_color")}
                                                    value={formFields?.progress_bar_color}
                                                />
                                                <input
                                                    type="text"
                                                    className="hex-text"
                                                    value={formFields?.progress_bar_color}
                                                    onChange={(e) => {
                                                        if (/^#[0-9a-fA-F]{6}$/.test(e.target.value)) {
                                                            setValue('progress_bar_color', e.target.value);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="cfg-form-label">Quick presets</label>
                                            <div className="swatch-row">
                                                {PRESET_COLORS.map((color) => (
                                                    <div
                                                        key={color}
                                                        className={`swatch${formFields?.progress_bar_color === color ? ' active' : ''}`}
                                                        style={{ background: color }}
                                                        onClick={() => setValue('progress_bar_color', color)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {widgetType === 'goal' && <div className="cfg-form-divider"></div>}

                            {/* ── BORDER Section ── */}
                            {widgetType === 'goal' && (
                                <div className="sub-section">
                                    <div className="sub-label">Border</div>
                                    <div className="form-group">
                                        <label className="cfg-form-label">Outline size</label>
                                        <div className="slider-row">
                                            <span className="slider-val">{formFields?.border_outline}</span>
                                            <input
                                                type="range"
                                                {...register("border_outline" , { valueAsNumber: true })}
                                                min={0}
                                                max={4}
                                                step={1}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {widgetType === 'goal' && <div className="cfg-form-divider"></div>}

                            {/* ── DISPLAY Section ── */}
                            {widgetType === 'goal' && (showCountRow || isCard)  ? (
                                <div className="sub-section">
                                    <div className="sub-label">Display</div>

                                    {showCampaignRow && (
                                        <div className="toggle-row">
                                            <div>
                                                <div className="toggle-label">Campaign name</div>
                                                <div className="toggle-desc">Show campaign title above the bar</div>
                                            </div>
                                            <label className="cfg-toggle">
                                                <input type="checkbox" {...register("show_campaign")} />
                                                <span className="cfg-toggle-track"></span>
                                            </label>
                                        </div>
                                    )}

                                    {showDescRow && (
                                        <div className="toggle-row">
                                            <div>
                                                <div className="toggle-label">Subtitle</div>
                                                <div className="toggle-desc">Show campaign subtitle text</div>
                                            </div>
                                            <label className="cfg-toggle">
                                                <input type="checkbox" {...register("show_description")} />
                                                <span className="cfg-toggle-track"></span>
                                            </label>
                                        </div>
                                    )}

                                    {showCountRow && (
                                    <div className="toggle-row">
                                        <div>
                                            <div className="toggle-label">Donation count</div>
                                            <div className="toggle-desc">Show total number of donations</div>
                                        </div>
                                        <label className="cfg-toggle">
                                            <input type="checkbox" {...register("show_donations")} />
                                            <span className="cfg-toggle-track"></span>
                                        </label>
                                    </div>
                                    )}

                                    {showBtnRow && (
                                        <div className="toggle-row">
                                            <div>
                                                <div className="toggle-label">Donate button</div>
                                                <div className="toggle-desc">Show call-to-action donate button</div>
                                            </div>
                                            <label className="cfg-toggle">
                                                <input type="checkbox" {...register("show_donate_btn")} />
                                                <span className="cfg-toggle-track"></span>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            ) : ''}

                            {/* ── BUTTON TEXT Section (card only) ── */}
                            {widgetType === 'goal' && showBtnTextSection && (
                                <>
                                    <div className="cfg-form-divider"></div>
                                    <div className="sub-section">
                                        <div className="sub-label">Button</div>
                                        <div className="form-group">
                                            <label className="cfg-form-label">Button label</label>
                                            <input
                                                type="text"
                                                {...register("btn_text")}
                                                className="cfg-form-input"
                                                value={formFields?.btn_text}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* ── RIGHT: Preview ── */}
                        <div className="preview-panel">
                            <div className="preview-header">
                                <span className="preview-title">Preview</span>
                                {widgetType === 'goal' && (
                                    <div className="preview-bg-toggle">
                                        <span className={`preview-bg-btn${!isDark ? ' active' : ''}`} onClick={() => setIsDark(false)}>Light</span>
                                        <span className={`preview-bg-btn${isDark ? ' active' : ''}`} onClick={() => setIsDark(true)}>Dark</span>
                                    </div>
                                )}
                            </div>
                            <div className={`preview-area${isDark ? ' bg-dark-preview' : ' bg-light-preview'}`}>
                                {widgetType === 'button' ? (
                                    <button className="btn" onClick={(e) => e.preventDefault()} style={{ ...previewStyle, ...{ top: '50%', left: '50%', position: 'absolute', transform: 'translate(-50%, -50%)' } }}>
                                        {formFields?.icon !== 'none' ?
                                            formFields?.icon_position === 'left' ?
                                                <>{formFields?.icon === 'heart' ?
                                                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2 8L1.21875 7.25C0.4375 6.46875 0 5.375 0 4.25C0 1.90625 1.875 0 4.21875 0C5.34375 0 6.4375 0.46875 7.21875 1.25L8 2L8.75 1.25C9.53125 0.46875 10.625 0 11.75 0C14.0938 0 16 1.90625 16 4.25C16 5.375 15.5312 6.46875 14.75 7.25L14 8L8 14L2 8Z" fill={formFields?.text_color}></path>
                                                    </svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.9375 2.15625C5.71875 1.75 5.28125 1.5 4.8125 1.5H4.75C4.03125 1.5 3.5 2.0625 3.5 2.75C3.5 3.46875 4.03125 4 4.75 4H7H7.03125L5.9375 2.15625ZM2 2.75C2 1.25 3.21875 0 4.75 0H4.8125C5.8125 0 6.71875 0.53125 7.21875 1.40625L8 2.6875L8.75 1.40625C9.25 0.53125 10.1562 0 11.1562 0H11.25C12.75 0 14 1.25 14 2.75C14 3.21875 13.875 3.625 13.6875 4H16V8H0V4H2.28125C2.09375 3.625 2 3.21875 2 2.75ZM12.5 2.75C12.5 2.0625 11.9375 1.5 11.25 1.5H11.1562C10.6875 1.5 10.2812 1.75 10.0312 2.15625L8.9375 4H9H11.25C11.9375 4 12.5 3.46875 12.5 2.75ZM1 9H7V16H1V9ZM9 16V9H15V16H9Z" fill={formFields?.text_color}></path>
                                                    </svg>}{formFields?.button_text} </> : <>{formFields?.button_text}{formFields?.icon === 'heart' ? <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2 8L1.21875 7.25C0.4375 6.46875 0 5.375 0 4.25C0 1.90625 1.875 0 4.21875 0C5.34375 0 6.4375 0.46875 7.21875 1.25L8 2L8.75 1.25C9.53125 0.46875 10.625 0 11.75 0C14.0938 0 16 1.90625 16 4.25C16 5.375 15.5312 6.46875 14.75 7.25L14 8L8 14L2 8Z" fill={formFields?.text_color}></path>
                                                    </svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.9375 2.15625C5.71875 1.75 5.28125 1.5 4.8125 1.5H4.75C4.03125 1.5 3.5 2.0625 3.5 2.75C3.5 3.46875 4.03125 4 4.75 4H7H7.03125L5.9375 2.15625ZM2 2.75C2 1.25 3.21875 0 4.75 0H4.8125C5.8125 0 6.71875 0.53125 7.21875 1.40625L8 2.6875L8.75 1.40625C9.25 0.53125 10.1562 0 11.1562 0H11.25C12.75 0 14 1.25 14 2.75C14 3.21875 13.875 3.625 13.6875 4H16V8H0V4H2.28125C2.09375 3.625 2 3.21875 2 2.75ZM12.5 2.75C12.5 2.0625 11.9375 1.5 11.25 1.5H11.1562C10.6875 1.5 10.2812 1.75 10.0312 2.15625L8.9375 4H9H11.25C11.9375 4 12.5 3.46875 12.5 2.75ZM1 9H7V16H1V9ZM9 16V9H15V16H9Z" fill={formFields?.text_color}></path>
                                                    </svg>}</>
                                            : formFields?.button_text}
                                    </button>
                                ) : widgetType === 'goal' ? (
                                    formFields?.progress_bar_type === 'thermometer' ? (
                                        <ThermometerGoalWidget
                                            size={formFields?.size}
                                            accentColor={formFields?.progress_bar_color}
                                            outline={Number(formFields?.border_outline)}
                                            darkMode={isDark}
                                            showCampaign={formFields?.show_campaign}
                                            showDonations={formFields?.show_donations}
                                            campaign={props?.title}
                                        />
                                    ) : formFields?.progress_bar_type === 'bar' ? (
                                        <ProgressBarWidget
                                            size={formFields?.size}
                                            accentColor={formFields?.progress_bar_color}
                                            outline={Number(formFields?.border_outline)}
                                            darkMode={isDark}
                                            showCampaign={formFields?.show_campaign}
                                            showDonations={formFields?.show_donations}
                                            campaign={props?.title}
                                        />
                                    ) : (
                                        <DonationCardWidget
                                            size={formFields?.size}
                                            accentColor={formFields?.progress_bar_color}
                                            outline={Number(formFields?.border_outline)}
                                            darkMode={isDark}
                                            showDescription={formFields?.show_description}
                                            showDonations={formFields?.show_donations}
                                            showDonateBtn={formFields?.show_donate_btn}
                                            btnText={formFields?.btn_text}
                                            campaign={props?.title}
                                            description={props?.desc}
                                        />
                                    )
                                ) : ''}
                            </div>
                        </div>

                    </div>

                    <div className="config-actions">
                        <button type="button" className="cfg-btn-secondary" onClick={() => { navigate(`/sharing-donation/${target_id}/${type}`) }}>Cancel</button>
                        <button type="submit" className="cfg-btn-primary">Publish</button>
                    </div>
                </form>
            </FormProvider>
            {dataLoader ? <Loader /> : ''}
        </div>
    );
};

export default WidgetConfigurator;

const CONFIG_CSS = `
  /* ── Layout ── */
  .config-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  @media (max-width: 991px) { .config-grid { grid-template-columns: 1fr; } }

  /* ── Form Card ── */
  .form-card { background: #fff; border-radius: 10px; border: 1px solid #e8eaed; padding: 20px 22px; }

  /* ── Sections ── */
  .sub-section { margin-bottom: 14px; }
  .sub-section:last-child { margin-bottom: 0; }
  .sub-label { font-size: 11px; font-weight: 700; color: #aaa; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 8px; }
  .cfg-form-divider { border: none; border-top: 1px solid #f0f0f0; margin: 12px 0; }
  .card-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  @media (max-width: 575px) { .card-row { grid-template-columns: 1fr; } }

  /* ── Form Elements ── */
  .form-group { margin-bottom: 12px; }
  .form-group:last-child { margin-bottom: 0; }
  .cfg-form-label { font-size: 12px; font-weight: 600; color: #555; margin-bottom: 5px; display: block; }
  .cfg-form-input {
    width: 100%; padding: 8px 12px;
    border: 1px solid #e8eaed; border-radius: 7px;
    font-size: 13px; color: #1a1a2e; outline: none;
    background: #fff; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    transition: border-color .15s;
  }
  .cfg-form-input:focus { border-color: #0047AB; }
  .cfg-form-select {
    width: 100%; padding: 8px 32px 8px 12px;
    border: 1px solid #e8eaed; border-radius: 7px;
    font-size: 13px; color: #1a1a2e; outline: none;
    background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23999' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat right 12px center;
    appearance: none; cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    transition: border-color .15s;
  }
  .cfg-form-select:focus { border-color: #0047AB; }

  /* ── Size Selector ── */
  .size-selector { display: flex; gap: 5px; }
  .size-btn {
    flex: 1; padding: 6px 0;
    border: 1px solid #e8eaed; border-radius: 7px;
    background: #fff; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 13px; font-weight: 600; color: #888;
    cursor: pointer; text-align: center;
    transition: all .15s;
  }
  .size-btn:hover { border-color: #ccc; color: #1a1a2e; }
  .size-btn.active { border-color: #0047AB; background: #e6edf8; color: #0047AB; }

  /* ── Color Input ── */
  .color-input {
    display: flex; align-items: center; gap: 7px;
    border: 1px solid #e8eaed; border-radius: 7px;
    padding: 3px 8px; background: #fff;
    transition: border-color .15s;
  }
  .color-input:focus-within { border-color: #0047AB; }
  .color-input input[type="color"] {
    -webkit-appearance: none; border: none;
    width: 26px; height: 26px; cursor: pointer; padding: 0;
    border-radius: 6px; overflow: hidden;
  }
  .color-input input[type="color"]::-webkit-color-swatch-wrapper { padding: 0; }
  .color-input input[type="color"]::-webkit-color-swatch { border: none; border-radius: 4px; }
  .color-input .hex-text {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 13px; color: #1a1a2e;
    border: none; outline: none; width: 72px; background: transparent;
  }

  /* ── Swatches ── */
  .swatch-row { display: flex; gap: 5px; margin-top: 2px; }
  .swatch {
    width: 28px; height: 28px;
    border-radius: 6px; cursor: pointer;
    border: 2px solid #e8eaed;
    transition: border-color .15s, transform .1s;
  }
  .swatch:hover { transform: scale(1.08); }
  .swatch.active { border-color: #1a1a2e; }

  /* ── Range Slider ── */
  .slider-row { display: flex; align-items: center; gap: 9px; }
  .slider-val { font-size: 13px; font-weight: 600; color: #1a1a2e; min-width: 16px; text-align: center; }
  .slider-row input[type="range"] { flex: 1; accent-color: #0047AB; }

  /* ── Toggle Switches ── */
  .toggle-row { display: flex; align-items: center; justify-content: space-between; padding: 7px 0; }
  .toggle-row + .toggle-row { border-top: 1px solid #f0f0f0; }
  .toggle-label { font-size: 12.5px; font-weight: 500; color: #444; }
  .toggle-desc  { font-size: 11px; color: #aaa; margin-top: 1px; }
  .cfg-toggle { position: relative; width: 36px; height: 20px; flex-shrink: 0; }
  .cfg-toggle input { opacity: 0; width: 0; height: 0; position: absolute; }
  .cfg-toggle-track {
    position: absolute; cursor: pointer;
    top: 0; left: 0; right: 0; bottom: 0;
    background: #ddd; border-radius: 99px;
    transition: background .2s;
  }
  .cfg-toggle-track::after {
    content: ''; position: absolute;
    width: 14px; height: 14px; left: 3px; top: 3px;
    background: #fff; border-radius: 50%;
    transition: transform .2s;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }
  .cfg-toggle input:checked + .cfg-toggle-track { background: #0047AB; }
  .cfg-toggle input:checked + .cfg-toggle-track::after { transform: translateX(16px); }

  /* ── Preview Panel ── */
  .preview-panel { display: flex; flex-direction: column; }
  .preview-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
  .preview-title { font-size: 13px; font-weight: 700; color: #1a1a2e; }
  .preview-bg-toggle { display: flex; gap: 3px; background: #f4f5f7; border-radius: 6px; padding: 2px; }
  .preview-bg-btn {
    padding: 3px 10px; border: none; border-radius: 4px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 11px; font-weight: 600;
    cursor: pointer; transition: all .15s;
    background: transparent; color: #aaa;
  }
  .preview-bg-btn.active { background: #fff; color: #1a1a2e; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
  .preview-area {
    flex: 1; border-radius: 10px;
    border: 1px solid #e8eaed; padding: 28px 20px;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 0;
    transition: background .3s; min-height: 280px;
    position: relative;
  }
  .preview-area.bg-light-preview { background: #ffffff; }
  .preview-area.bg-dark-preview  { background: #1a1a2e; border-color: #333; }

  /* ── Action Buttons ── */
  .config-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }
  .cfg-btn-primary {
    background: #1a1a2e; color: #fff; border: none; border-radius: 8px;
    padding: 9px 18px; font-size: 13px; font-weight: 600; cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    transition: background .12s;
  }
  .cfg-btn-primary:hover { background: #2d2d4e; }
  .cfg-btn-secondary {
    background: #fff; color: #555; border: 1px solid #e8eaed; border-radius: 8px;
    padding: 9px 18px; font-size: 13px; font-weight: 600; cursor: pointer;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    transition: background .12s;
  }
  .cfg-btn-secondary:hover { background: #f4f5f7; }
`;